let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kFFBo")).then(() => parcelRequire('cJxZP'));